import {
  BUILD_DATA_REPORT_LOADING,
  BUILD_DATA_REPORT_SUCCESS,
  BUILD_DATA_REPORT_FAILED
} from "../actionTypeConstants/PdfReport";

import findIndex from "lodash/findIndex";
import pullAt from "lodash/pullAt";

const initialState = {
  buildReportDetail: {
    loading: false,
    data: null,
    error: null
  },
  buildReportStatus: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case BUILD_DATA_REPORT_LOADING:
      return {
        ...state,
        buildReportDetail: {
          ...state.buildReportDetail,
          loading: true,
          data: null,
          error: null
        }
      };
    case BUILD_DATA_REPORT_SUCCESS:
      return {
        ...state,
        buildReportDetail: {
          ...state.buildReportDetail,
          loading: false,
          data: action.result.data,
          error: null
        }
      };
    case BUILD_DATA_REPORT_FAILED:
      return {
        ...state,
        buildReportDetail: {
          ...state.buildReportDetail,
          loading: false,
          error: action.error.response,
          data: null
        }
      };
    case "SET_BUILD_REPORT_STATUS":
      let reportArray = state.buildReportStatus;
      reportArray.push(action.build);
      return {
        ...state,
        buildReportDetail: {
          ...state.buildReportDetail
        },
        buildReportStatus: reportArray
      };
    case "CLEAR_BUILD_REPORT_STATUS":
      let reportArr = state.buildReportStatus;
      let index = findIndex(reportArr, { buildId: action.buildId });
      if (index > -1) {
        pullAt(reportArr, [index]);
      }
      return {
        ...state,
        buildReportDetail: {
          ...state.buildReportDetail
        },
        buildReportStatus: reportArr
      };
    default:
      return state;
  }
}
